export enum CollaborationCancellationReasonCode {
  PersonalCircumstances = "PERSONAL_CIRCUMSTANCES",
  ContentRequirementsExpanded = "CONTENT_REQUIREMENTS_EXPANDED",
  PaymentNoLongerWorks = "PAYMENT_NO_LONGER_WORKS",
  NeedMoreTime = "NEED_MORE_TIME",
  ProductOrShippingIssue = "PRODUCT_OR_SHIPPING_ISSUE",
  Other = "OTHER",
}

export type CollaborationCancellationRefundSource =
  | {
      type: "balance";
    }
  | {
      type: "card";
      cardBrand?: string;
      card?: {
        last4?: string;
      };
    };

export interface CollaborationCancellationRefund {
  amount?: number;
  currency?: string;
  triggeredAt?: string;
  sources?: CollaborationCancellationRefundSource[];
}

export interface CollaborationCancellation {
  orderId: string;
  reasonCode: CollaborationCancellationReasonCode;
  note?: string;
  cancelledAt: string;
  refund?: CollaborationCancellationRefund;
}

export interface CreatorCancellationApiDetail {
  reasonCode: unknown;
  notes?: string;
  submittedAt?: string;
}

export interface CreatorCancellationOrder {
  id?: string;
  _id?: string;
  creatorProfileLink?: string;
  cancelType?: string;
  status?: string;
  cancelledAt?: string;
  refund?: CollaborationCancellationRefund;
  refundAmount?: number;
  creatorCancellation?: CreatorCancellationApiDetail;
}
